"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NoneHereYet", {
    enumerable: true,
    get: function() {
        return NoneHereYet;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const defaultWidth = 226;
const defaultHeight = 120;
const aspectRatio = defaultHeight / defaultWidth;
const NoneHereYet = (param)=>{
    let { size: width = defaultWidth, className } = param;
    const height = width * aspectRatio;
    return /*#__PURE__*/ _react.default.createElement("svg", {
        width: width,
        height: height,
        className: className,
        viewBox: "0 0 ".concat(defaultWidth, " ").concat(defaultHeight),
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ _react.default.createElement("rect", {
        y: "24",
        width: "72",
        height: "72",
        rx: "4",
        fill: "#E6E6E6"
    }), /*#__PURE__*/ _react.default.createElement("rect", {
        x: "154",
        y: "20",
        width: "72",
        height: "80",
        rx: "4",
        fill: "#E6E6E6"
    }), /*#__PURE__*/ _react.default.createElement("rect", {
        x: "54",
        width: "120",
        height: "120",
        rx: "4",
        fill: "#808080"
    }), /*#__PURE__*/ _react.default.createElement("rect", {
        x: "70",
        y: "84",
        width: "72",
        height: "9",
        fill: "#CCCCCC"
    }), /*#__PURE__*/ _react.default.createElement("rect", {
        x: "70",
        y: "98",
        width: "40",
        height: "6",
        fill: "#999999"
    }));
};
NoneHereYet.displayName = "NoneHereYet";

//# sourceMappingURL=NoneHereYet.js.map